import { Radio } from "antd";
import classNames from "classnames";
import {
  INDEX_CAPABILITY,
  INDEX_CAPABILITY_TYPES,
  INDEX_TYPES,
} from "helpers/constants/indexTypes";

import styles from "./style.module.scss";

const IndexTypeDropdown = ({
  dropdownRef,
  selectedIndexType,
  handleSelection,
}: IndexTypeDropdownProps) => {
  return (
    <div ref={dropdownRef} className={styles.dropdown}>
      <div className={styles.header}>Select Index Type</div>
      <Radio.Group
        value={selectedIndexType}
        onChange={(e) => handleSelection(e.target.value)}
        className={styles.radioGroup}
      >
        {INDEX_TYPES.map((item) => (
          <div
            key={item.id}
            className={classNames(styles.indexType, {
              [styles.active]: item.id === selectedIndexType,
            })}
            onClick={() => handleSelection(item.id)}
          >
            <Radio value={item.id}>
              <div className={styles.content}>
                <div className={styles.name}>{item.name}</div>
                <div className={styles.capabilities}>
                  {item.capabilitiesTypes.map((capabilitiesType, idx) => (
                    <div key={idx} className={styles.capabilitiesType}>
                      {INDEX_CAPABILITY_TYPES[capabilitiesType]}
                    </div>
                  ))}
                  {item.capabilities.map((capability, idx) => (
                    <div key={idx} className={styles.capability}>
                      {INDEX_CAPABILITY[capability].icon}
                      <div>{INDEX_CAPABILITY[capability].text}</div>
                    </div>
                  ))}
                </div>
              </div>
            </Radio>
          </div>
        ))}
      </Radio.Group>
    </div>
  );
};

export default IndexTypeDropdown;

interface IndexTypeDropdownProps {
  dropdownRef: React.RefObject<HTMLDivElement>;
  selectedIndexType: string;
  handleSelection: (indexTypeId: string) => void;
}
